import React from 'react';
import autoBind from 'react-autobind';
import SmartModal from '@common/components/modals/smartModal';
import { Modal, Row, Col } from 'react-bootstrap';
//Context
import { withGridContext } from './grid.factory';

class GridViewFilter extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  onClose() {
    const { context } = this.props;
    context.setState({ showViewFilter: false }, false);
  }

  renderInput(column, input) {
    const { value } = input;

    switch (column.type) {
      case 'decimal':
        return (value || 0).toLocaleString(navigator.language, {
          minimumFractionDigits: column.places || 2,
        });
      case 'date':
        return `${value} ${input.valueTime}`;
      case 'lista':
        return '';
      default:
        return value;
    }
  }

  get filterValue() {
    let filterValue = [];

    const { context } = this.props;

    const { columns } = context;

    filterValue = columns
      .filter((x) => x.isFiltered)
      .map((column) => {
        return {
          Title: column.fieldName,
          AdvancedSearch: column.isAdvancedSearch,
          IsNot: column.inputs.some((x) => x.isNot),
          Content: column.inputs
            .filter(
              (x) =>
                (x.value && column.type != 'lista') ||
                (x.advancedSearchValues && x.advancedSearchValues.length > 0) ||
                (column.type == 'lista' && x.check)
            )
            .map((input) => {
              let content = {
                Description: input.title,
                Value: undefined,
                Icon: input.icon,
                IconCss: input.iconCss,
              };
              if (column.isAdvancedSearch) {
                let mappedRender = input.advancedSearchValues.map((x) => this.renderInput(column, { value: x }));
                content.Value = mappedRender.join(input.advancedSearchOperator == 'and' ? ' e ' : ' ou ');
              } else {
                content.Value = this.renderInput(column, input);
              }
              return content;
            }),
        };
      });

    return filterValue;
  }

  render() {
    const { context } = this.props;
    const filterValue = context.showViewFilter ? this.filterValue : [];

    return (
      <SmartModal show={context.showViewFilter} onHide={this.onClose} keyboard size="lg" backdrop="static">
        <Modal.Header>
          <Modal.Title>
            <h3>Filtro</h3>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="well">
            <div className="box-form-cadastro">
              {filterValue.length == 0 && <div>Nenhum filtro definido.</div>}

              {filterValue.map((item, i) => (
                <Row key={i}>
                  <Col lg={12}>
                    <h5>{item.Title}</h5>
                  </Col>

                  {item.Content.map((content, iContent) => (
                    <Col lg={12} className="pl-5" key={iContent}>
                      <label className="control-label">
                        {content.Icon && <i className={`${content.Icon} ${content.IconCss || ''} mr-1`} />}
                        {content.Description}
                        <b>{content.Value}</b>
                      </label>
                    </Col>
                  ))}

                  {item.IsNot && (
                    <Col lg={12} className="pl-5">
                      <label className="control-label">
                        <b>Registros não coincidentes</b>
                      </label>
                    </Col>
                  )}
                </Row>
              ))}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button onClick={this.onClose} className="btn btn-cancel">
            <i className="fa fa-times" /> Fechar
          </button>
        </Modal.Footer>
      </SmartModal>
    );
  }
}

export default withGridContext(GridViewFilter);
